/**
 * AddStudentsButton
 */

import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import makeAdminLink from 'utils/makeAdminLink.js';
import Icon2 from 'components/media/Icon2/index.js';
import AddUserModal from '../AddUserModal.jsx';
import schema from './form.js';
import messages from './messages.js';

function AddStudentsButton() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const intl = useIntl();
  const role = useCurrentRole();
  const adminLink = makeAdminLink(role, '/AdministrationLink');
  const title = intl.formatMessage(messages.addStudent);
  const defaultValues = { adminGroup: undefined };
  return (
    <>
      <DropdownButton
        variant="light"
        title={title}
        key={1}
        align="end"
        id="add-students"
      >
        <Dropdown.Item eventkey="1" onClick={() => navigate('/admin/users/invite/student')}><FormattedMessage {...messages.inviteStudents} /></Dropdown.Item>
        <Dropdown.Item eventkey="2" onClick={() => setShow(true)}><FormattedMessage {...messages.individualStudent} /></Dropdown.Item>
        <Dropdown.Item eventkey="3" href={adminLink}>
          <FormattedMessage {...messages.importStudents} />
          <Icon2 className="ms-2 ss-external-link fs-6" />
        </Dropdown.Item>
      </DropdownButton>

      <AddUserModal show={show} title={messages.addStudent} type="student" schema={schema} defaultValues={defaultValues} onClose={() => setShow(false)} />
    </>
  );
}

export default AddStudentsButton;
